import styles from './style.module.css';
interface ICard {
  shadow?: boolean;
  isLarge?: boolean;
  children: any;
  style?: any;
}

export function Card({ shadow, isLarge, children, ...rest }: ICard) {
  return (
    <>
      {shadow && isLarge && (
        <div
          {...rest}
          className={`${styles.card} ${styles.shadow} ${styles.large}`}
        >
          {children}
        </div>
      )}
      {!shadow && isLarge && (
        <div {...rest} className={`${styles.card} ${styles.large}`}>
          {children}
        </div>
      )}
      {shadow && !isLarge && (
        <div {...rest} className={`${styles.card} ${styles.shadow}`}>
          {children}
        </div>
      )}
      {!shadow && !isLarge && (
        <div {...rest} className={styles.card}>
          {children}
        </div>
      )}
    </>
  );
}
